<template lang="pug">
  section.main.action(v-if="action")
    the-heading(:detail="true" :action="action")
    .wrpapper
      .columns.is-mobile.is-gapless
        aside.column.is-two-fifths-desktop(:class="{minimize: minimize}")
          .columns.is-mobile.is-gapless
            .column.is-left
              transition(name="fade" mode="out-in")
                keep-alive
                  component(:is="currentComponent.name" v-bind="currentComponent.props")
            .column.navigation-menu
              the-navigation-action(:action="action" :idFase="idFase" :minimize="minimize")
        .column
          the-map
    alert-responsive
  section.nodata(v-else)
    app-loader(color="#1c6dbe")
</template>

<script>
import TheHeading from '@/components/TheHeading'
import AlertResponsive from '@/components/AlertResponsive'
import TheInformation from '@/components/TheInformation'
import TheCharacterization from '@/components/TheCharacterization'
import TheIndicators from '@/components/TheIndicators'
import TheNavigationAction from '@/components/TheNavigationAction'
import TheMap from '@/components/TheMap'
import AppLoader from '@/components/AppLoader'
export default {
  name: 'Action',
  components: {
    AlertResponsive,
    TheHeading,
    TheInformation,
    TheCharacterization,
    TheIndicators,
    TheNavigationAction,
    AppLoader,
    TheMap
  },
  computed: {
    minimize () {
      return this.$store.getters.minimize
    },
    action () {
      return this.$store.getters.action({id: this.idAction, fase: this.fase})
    },
    actions () {
      return this.$store.getters.actions
    },
    characterizationConfigurator () {
      return this.$store.getters.characterizationConfigurator
    },
    indicatorsConfigurator () {
      return this.$store.getters.indicatorsConfigurator
    },
    idAction: function () {
      return this.$route.params.id
    },
    fase: function () {
      return this.$route.params.fase
    },
    idFase: function () {
      return this.$route.params.fase
    },
    currentComponent: function () {
      if (this.$route.name === 'action') {
        return {
          name: 'the-information',
          props: {
            action: this.action,
            idFase: this.idFase
          }
        }
      } else if (this.$route.name === 'characterization') {
        return {
          name: 'the-characterization',
          props: {
            action: this.action,
            idFase: this.idFase,
            configurator: this.characterizationConfigurator
          }
        }
      } else if (this.$route.name === 'indicators') {
        return {
          name: 'the-indicators',
          props: {
            action: this.action,
            idFase: this.idFase,
            configurator: this.indicatorsConfigurator
          }
        }
      } else {
        return {
          name: 'the-information',
          props: {
            action: this.action,
            idFase: this.idFase
          }
        }
      }
    }
  },
  data () {
    return {
      placeholder: false
    }
  },
  watch: {
    '$route.params.fase': function (fase) {
      // Update Action
      // const filters = `Azioni.idAzione='${this.idAction}' AND Azioni.fase='${this.fase}'`
      // this.$store.dispatch('LOAD_ACTIONS', {filters: filters})
      // Update Indicators by fase
      // this.$store.dispatch('LOAD_INDICATORS_CONFIGURATOR', {idAzione: this.idAction, fase: fase})
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init () {
      this.$store.commit('SET_INDICATORS_CONFIGURATOR', [])
      const filters = `Azioni.idAzione='${this.idAction}' AND Azioni.fase='${this.fase}'`
      this.$store.dispatch('LOAD_CONFIG').then(results => {
        this.$store.dispatch('LOAD_ACTIONS', {filters: filters, config: results}).then(response => {
          this.$store.commit('SET_LOADING', false)
          const byIntervento = `TBL_Interventi.intervento='${this.action['TBL_Interventi.intervento']}'`
          this.$store.dispatch('LOAD_ACTIONS', {filters: byIntervento, fase: false, config: results}).then(response => {
          }, error => {
            console.error('NOT LOADED', error)
          })
        }, error => {
          console.error('NOT LOADED', error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nodata {
  padding-top: 10vw;
  text-align: center;
  width: auto;
  height: 50vh;
}
.action {
  aside {
    background-color: #ffffff;
    padding-left: 0;
    transition: .1s ease-in;
  }
  & > .columns > .column {
    min-height: 100vh;
  }
  .is-left,
  .navigation-menu {
    padding-right: 0;
    opacity: 1;
    height: 90.7vh;
    transition: .1s ease-out;
  }
  .is-left {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .navigation-menu {
    padding: 0;
    padding-top: .7em;
    max-width: 60px;
    background-color: lighten($link, 2%);
  }

  .minimize {
    max-width: 3.7em;
    transition: .2s ease-in-out;
    .is-left {
      height: 0;
      overflow: hidden;
      max-width: 0;
      opacity: 0;
      transition: .1s ease-in-out;
      .content {
        padding: 0;
      }
    }
  }

// ℹ️ Animations
// 🔗 https://vuejs.org/v2/guide/transitions.html
.fade-enter-active {
  transition: all .4s ease;
}
.fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .slide-fade-leave-to {
  transform: scale(.5);
  opacity: 0;
}
}
</style>



// WEBPACK FOOTER //
// src/views/Action.vue